export const headingFamily = '"Source Serif 4", Georgia, serif';
export const bodyFamily = ['Manrope', 'system-ui', '-apple-system', 'Segoe UI', 'sans-serif'].join(',');
export const devanagariFamily = [
  '"Noto Serif Devanagari"',
  '"Kohinoor Devanagari"',
  '"Nirmala UI"',
  'Mangal',
  'serif',
].join(', ');

/** Lining figures for statistics and stage numbers. */
export const figureSx = {
  fontFamily: bodyFamily,
  fontWeight: 700,
  fontVariantNumeric: 'lining-nums tabular-nums',
  letterSpacing: '-0.03em',
  lineHeight: 1.1,
};

export const typography = {
  fontFamily: bodyFamily,
  fontSize: 16,
  htmlFontSize: 16,
  h1: {
    fontFamily: headingFamily,
    fontWeight: 500,
    letterSpacing: '-0.03em',
    lineHeight: 1.05,
    fontSize: 'clamp(2.35rem, 5.6vw, 4.75rem)',
    overflowWrap: 'break-word',
  },
  h2: {
    fontFamily: headingFamily,
    fontWeight: 500,
    letterSpacing: '-0.025em',
    lineHeight: 1.12,
    fontSize: 'clamp(1.85rem, 2.8vw, 2.85rem)',
    overflowWrap: 'break-word',
  },
  h3: {
    fontFamily: headingFamily,
    fontWeight: 600,
    letterSpacing: '-0.01em',
    lineHeight: 1.25,
    fontSize: 'clamp(1.25rem, 2vw, 1.75rem)',
    overflowWrap: 'break-word',
  },
  h4: {
    fontFamily: bodyFamily,
    fontWeight: 600,
    letterSpacing: '-0.01em',
    lineHeight: 1.3,
    fontSize: '1.125rem',
  },
  subtitle1: {
    fontFamily: bodyFamily,
    fontWeight: 500,
    lineHeight: 1.65,
    fontSize: '1.0625rem',
  },
  body1: {
    fontFamily: bodyFamily,
    fontWeight: 400,
    lineHeight: 1.7,
    fontSize: '1rem',
  },
  body2: {
    fontFamily: bodyFamily,
    fontWeight: 400,
    lineHeight: 1.65,
    fontSize: '0.9375rem',
  },
  overline: {
    fontFamily: bodyFamily,
    fontWeight: 600,
    letterSpacing: '0.16em',
    lineHeight: 1.4,
    fontSize: '0.72rem',
    textTransform: 'uppercase',
  },
  button: {
    fontFamily: bodyFamily,
    fontWeight: 600,
    letterSpacing: '0.02em',
    textTransform: 'none',
    fontSize: '0.9375rem',
  },
  caption: {
    fontFamily: bodyFamily,
    fontSize: '0.8125rem',
    lineHeight: 1.5,
  },
};
